import { Grid } from "@material-ui/core";
import { Layout, useQuery } from "@roc/feature-app-core";
import { AutocompleteField, Button, SelectField, StandardDialog, TextField } from "@roc/ui";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useAppraisalsStore } from "../hooks";
import { useParams } from "react-router";
import { AppraisalsStore } from "../stores";

const useStyles = makeStyles({
  '@global': {
    body: {
      backgroundColor: 'transparent !important',
    },
  },
  instruction: {
    fontWeight: 600,
  },
  paymentDetails: {
    fontWeight: 800,
    marginTop: '20px',
    fontStyle: 'italic',
  },
  tabsContainer: {
    border: 'none !important',
    marginTop: '-35px',
  },
  container: {
    paddingTop: 12,
  },
  closeButtonContainer: {
    paddingTop: 16,
  },
  button: {
    width: '100%',
  },
});

type MoveAppraisalFormProps = {
  loanId: any;
  appraisalStore: AppraisalsStore;
};

const MoveAppraisalForm = observer(({loanId, appraisalStore}: MoveAppraisalFormProps) => {

  useEffect(() => {
    appraisalStore.getValidLoanFromMoveAppraisal(loanId)
  }, []);

  return(
    <Grid container spacing={2}>
      <Grid item container xs={12} md={12} direction="row" spacing={2}>
        <Grid item xs={6} md={6}>
          <AutocompleteField
            label='From Loan Id'
            placeHolder='From Loan Id'
            options={appraisalStore.loansFromMoveOptions}
            value={appraisalStore.selectedLoanId}
            onChange={(newValue) => {
              appraisalStore.onChangeLoanId(newValue);
            }}
            onSelect={(option: any) => {
              appraisalStore.setSelectedLoanId(option?.value);
            }}
          />
        </Grid>
        <Grid item xs={6} md={6}>
          <TextField
            testId="loanLoanId"
            variant="outlined"
            standaloneLabel={true}
            label="To Loan Id"
            disabled
            value={loanId}
            fullWidth
            required
          />
        </Grid>
      </Grid>
      <Grid item xs={12} md={12}>
        <SelectField
          testId={'property'}
          fullWidth
          label="Property Address"
          standaloneLabel
          variant="outlined"
          options={appraisalStore.propertiesOptions}
          value={appraisalStore.selectedProperty}
          onChange={value => {
            appraisalStore.setSelectedProperty(value);
          }}
          required={true}
          disabled={appraisalStore.selectedLoanId === ""}
        />
      </Grid>

    </Grid>
  )
})

export const MoveAppraisalModal = observer(() => {
  const [ openMoveAppraisalModal, setOpenMoveAppraisalModal ] = useState(false)
  const { loanId } = useParams<{ loanId: string }>();
  const { appraisalsStore } = useAppraisalsStore()

  const closeMoveAppraisalModal = () => {
    window.parent.postMessage({ action: 'close-modal' }, '*');
    setOpenMoveAppraisalModal(false);
  }
  const classes = useStyles();
  const createMoveAppraisalTask = () => {
    appraisalsStore.createTamariskTaskToMoveLoan(loanId);
  }

  const query = useQuery();

  useEffect(() => {
  if (query.get('openModal') === 'true') {
    setOpenMoveAppraisalModal(true);
    window.parent.postMessage({ action: 'modal-ready' }, '*');
  }
  }, [query]);

  return(
    <Layout maxWidth="lg">
      <Grid container spacing={2} style={{ width: '100%' }}>
        <StandardDialog
          title="Move Appraisal to this Loan"
          open={openMoveAppraisalModal}
          onClose={closeMoveAppraisalModal}
          handleClose={closeMoveAppraisalModal}
          removeContentBox
          dialogContent={
            <MoveAppraisalForm loanId={loanId} appraisalStore={appraisalsStore}/>
          }
          dialogActions={
            <Grid
              container
              spacing={2}
              xs={12}
              justifyContent="flex-end"
              className={classes.closeButtonContainer}
            >
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={closeMoveAppraisalModal}
                  testId="cancel"
                >
                  Close
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={createMoveAppraisalTask}
                  testId="cancel"
                >
                  Move
                </Button>
              </Grid>
            </Grid>
          }
        ></StandardDialog>
      </Grid>
    </Layout>
  )
})